import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { ExamChaptersService } from "../../../services/ExamService/ChapterService/chapter.service";
import ChapterForm from "../../../shared/components/CourseComponents/ChapterForm";
import SortableChapterList from "../../../shared/components/CourseComponents/SortableChapterList";
import EmptyState from "../../../shared/components/EmptyState";
import ChapterActions from "../../CourseStructure/Chapters/ChapterActions";
import CourseHeader from "../../../shared/components/AppHeader";
import "../../CourseStructure/Chapters/chapters.scss";
import { ExamContentService } from "../../../services/ExamService/ContentService/content.service";
import { ExamExerciseService } from "../../../services/ExamService/ExerciseService/exercise.service";
import { ExerciseModal } from "../../../models/ExerciseModal/Exercise.model";
const ExamChapters = (props: any) => {
  const [chapters, setChapters] = useState<any>([]);
  const [activeChapter, setActiveChapter] = useState<any>();
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const { subjectId } = props.match.params;
  const [exercises, setExercises] = useState<any>([]);
  const [contents, setContents] = useState<any>([]);
  useEffect(() => {
    fetchChapters();
  }, []);

  useEffect(() => {

  }, [props])

  const fetchChapters = (searchString?: string) => {
    let queryParams = `?exam_subject_id=${subjectId}&search=${
      searchString || ""
    }`;
    ExamChaptersService.fetchExamChapters(
      queryParams,
      (chapters: any, meta: any) => {
        console.log(chapters);
        setChapters(chapters);
        setActiveChapter(chapters.length > 0 ? chapters[0] : "");
      },
      (error: any) => {
        console.log(error);
      }
    );
  };
  const fetchChapterExerciseList = () => {
    ExamExerciseService.fetchExamExercises(
      {
        exam_chapter_id: activeChapter.id,
      },
      (response: any) => {
       setExercises(response);
       console.log(response)
      },
      () => {}
    );
  };

  const fetchChapterContentsList = () => {
    ExamContentService.fetchExamContents(
      {
        exam_chapter_id: activeChapter.id,
      },
      (response: any) => {
        console.log(response)
        setContents(response);
      },
      () => {},
    )
  };
  const handleSearch = (value: string) => {
    fetchChapters(value);
  };

  const handleNewBoard = () => {
    setFormVisible(true);
  };
  return (
    <div className="page-view chapters">
      <ChapterForm
        title="Create New Chapter"
        visible={formVisible}
        setVisible={setFormVisible}
        refreshList={fetchChapters}
      />
      <div className="chapter__header">
        <CourseHeader
          headerText="Chapters"
          handleSearch={handleSearch}
          handleHeaderAction={handleNewBoard}
          buttonText="Chapter"
          showBreadCrumb={true}
        />
      </div>
      {chapters.length !== 0 ? (
        <>
          <div className="chapter__list">
            <SortableChapterList
              list={chapters}
              setList={setChapters}
              menuText="Chapter"
              setActiveChapter={setActiveChapter}
              activeChapter={activeChapter}
              refreshList={fetchChapters}
            />
          </div>
          <div className="content__list">
            <ChapterActions exercises={exercises} contents={contents} activeChapter={activeChapter} fetchChapterContentsList={fetchChapterContentsList} fetchChapterExerciseList={fetchChapterExerciseList}/>
          </div>
        </>
      ) : (
        <EmptyState text={"No chapters found."} />
      )}
    </div>
  );
};
export default withRouter(ExamChapters);
